export function loadFootCode(transform: string, scale: number, color: string, rightFoot:boolean, visible: boolean) {
    let flip = -1;
    if (rightFoot) flip=1;
  
    return (<g transform={`${transform} scale(${flip*scale},${-scale})`} fill={color} visibility={visible ? "block" : "hidden"}>
        <path d="M1346 12583 c-297 -63 -542 -312 -662 -673 -16 -47 -32 -88 -38 -91
        -5 -4 -6 -14 -3 -23 4 -9 2 -16 -2 -16 -5 0 -17 -44 -28 -97 -26 -139 -26
        -477 1 -618 26 -144 96 -349 161 -474 217 -418 604 -660 955 -599 377 67 656
        388 761 878 19 89 23 136 23 315 1 263 -6 305 -96 580 -186 564 -641 911
        -1072 818z" />
        <path d="M3071 12004 c-163 -59 -299 -253 -336 -479 -4 -22 -14 -64 -22 -94
        -25 -87 -13 -337 21 -466 86 -323 309 -577 539 -615 240 -39 455 166 522 499
        14 66 16 116 12 230 -3 80 -10 162 -16 181 -5 19 -19 75 -31 124 -66 280 -220
        505 -405 593 -66 31 -90 37 -159 40 -56 2 -94 -2 -125 -13z"/>
        <path d="M4311 11480 c-103 -22 -201 -111 -261 -235 -36 -76 -48 -115 -86
        -283 -24 -106 -15 -295 21 -417 68 -234 199 -416 359 -497 85 -43 194 -50 281
        -17 84 31 179 127 228 229 60 126 72 185 71 360 0 145 -3 164 -37 294 -58 224
        -148 382 -275 481 -93 73 -204 105 -301 85z"/>
        <path d="M5360 10595 c-107 -36 -198 -141 -247 -288 -26 -79 -27 -90 -28 -297
        0 -180 3 -226 19 -284 60 -224 178 -391 326 -464 46 -23 68 -27 135 -27 98 0
        156 27 227 103 94 100 134 225 144 442 8 166 -6 281 -47 405 -41 121 -88 203
        -166 286 -111 117 -245 163 -363 124z"/>
        <path d="M2800 9694 c-14 -2 -65 -9 -113 -15 -49 -6 -139 -23 -200 -39 -609
        -150 -1121 -549 -1402 -1093 -34 -64 -65 -114 -69 -110 -4 4 -4 1 -1 -8 3 -8
        -6 -41 -19 -74 -14 -33 -25 -55 -26 -49 0 6 7 28 15 47 26 64 15 54 -16 -13
        -216 -466 -217 -908 -5 -1389 89 -203 197 -377 558 -903 157 -228 215 -323
        309 -503 148 -285 220 -548 221 -814 1 -378 -86 -661 -442 -1436 -210 -455
        -253 -557 -334 -775 -92 -247 -148 -482 -165 -690 -15 -185 -1 -337 48 -515
        17 -61 19 -66 21 -35 2 24 6 9 15 -45 42 -265 132 -441 330 -640 201 -203 441
        -338 688 -389 220 -46 474 22 688 184 92 69 226 213 294 315 109 163 219 413
        291 658 21 70 40 123 44 117 15 -23 121 372 225 840 141 633 225 908 376 1228
        21 46 39 85 39 88 0 9 241 486 305 604 58 109 107 200 267 505 525 997 749
        1587 823 2166 20 160 20 438 1 586 -28 204 -95 424 -178 583 -36 69 -39 72
        -22 23 3 -10 -23 38 -58 107 -175 346 -433 644 -777 898 -267 197 -659 397
        -988 502 -199 64 -310 81 -528 85 -104 2 -201 2 -215 -1z m-1839 -1431 c-12
        -20 -14 -14 -5 12 4 9 9 14 11 11 3 -2 0 -13 -6 -23z m4429 -218 c0 -5 -5 -3
        -10 5 -5 8 -10 20 -10 25 0 6 5 3 10 -5 5 -8 10 -19 10 -25z m-1853 -6537 c-3
        -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z"/>
        <path d="M5326 8197 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z"/>
    </g>);
  }